import React from "react";

const ThemeButton = ({
  text,
  onClick,
  type = "button",
  className = "",
  ...props
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`inline-flex items-center justify-center rounded-full bg-[linear-gradient(135deg,var(--accent),var(--accent-soft))] px-6 py-4 text-sm font-semibold text-white shadow-lg shadow-[var(--accent-glow)] transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-[var(--accent-glow)] ${className}`}
      {...props}
    >
      {text}
    </button>
  );
};

export default ThemeButton;
